
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 .5A19.5 19.5 0 1039.5 20 19.52 19.52 0 0020 .5zm0 36.77A17.27 17.27 0 1137.27 20 17.3 17.3 0 0120 37.27z"}}),_c('path',{attrs:{"d":"M28.41 19.06l-11.49-7.35a1.11 1.11 0 00-1.71.93v14.72a1.11 1.11 0 001.11 1.1 1.1 1.1 0 00.6-.17l11.5-7.35a1.11 1.11 0 000-1.88zm-2.66.94l-8.31 5.32V14.68z"}})])
          )
        }
      }
    